<!-- eslint-disable prettier/prettier -->
<!-- eslint-disable prettier/prettier -->
<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import type { PropType } from 'vue'

import { useShipStore } from '@/stores/ship'
import { useDocumentStore } from '@/stores/document'

import ShipActionMenu from '@/components/ships/ShipActionMenu.vue'
import DocumentDialog from '@/components/dialog/DocumentDialog.vue'
import ShipTable from '@/components/ships/ShipTable.vue'
import ImportShipDialogHandler from '@/components/import/ImportShipDialogHandler.vue'
import DownloadFileDialog from '@/components/dialog/DownloadFileDialog.vue'
import CreateUpdateShipDialog from '@/components/dialog/CreateUpdateShipDialog.vue'

defineProps({
	chartEvent: { type: String as PropType<string>, required: true }
})

const documentStore = useDocumentStore()
const shipStore = useShipStore()
const {
	documentDialog,
	currentItem,
	downloadTemplateDialog,
	downloadTemplateLoading,
	newItem: newShip,
	items: ships
} = storeToRefs(shipStore)

async function upload(): Promise<void> {
	if (currentItem.value?.id) {
		await documentStore.uploadDocumentFiles(currentItem.value.id)
	}
}

function close(): void {
	if (currentItem.value) {
		shipStore.addDocuments(currentItem.value)
	}
	documentStore.clearUnsavedDocuments()
	documentDialog.value = false
}

const downloadTemplate = async (): Promise<void> => {
	await shipStore.downloadTemplate()
	shipStore.toggleDownloadTemplateDialog(false)
}

const addShip = () => {
	newShip.value = shipStore.createNewShip(newShip.value)
	shipStore.openCreateUpdateDialog()
}

const createShip = async (): Promise<void> => {
	if (newShip.value) {
		const res = await shipStore.create(newShip.value)
		if (res) {
			shipStore.resetState()
			shipStore.closeCreateUpdateDialog()
			await shipStore.fetchPaginationItems()
			if (ships.value.length) {
				shipStore.setCurrentItem(ships.value[0])
			}
			newShip.value = null
		}
	}
}
</script>

<template>
	<div class="ship-tab">
		<ShipActionMenu class="ship-tab__actions py-2" @add-ship="addShip" />
		<ShipTable class="ship-tab__table" :chart-event="chartEvent" />
		<ImportShipDialogHandler />
		<CreateUpdateShipDialog @save="createShip" />
		<DownloadFileDialog
			v-model="downloadTemplateDialog"
			:loading="downloadTemplateLoading"
			name="template"
			@download="downloadTemplate"
		/>
		<DocumentDialog @upload="upload" @close="close" />
	</div>
</template>

<style scoped>
.ship-tab {
	display: flex;
	flex-direction: column;
	height: 100%;
	min-height: 0;
}

.ship-tab__actions {
	flex: 0 0 auto;
}

.ship-tab__table {
	flex: 1 1 auto;
	min-height: 0;
}
</style>
